import { useEffect, useState } from 'react';
import FieldProps from '../textFieldProps';
import { getResultColorClass } from '../utilites/get-color-scoring';

const CheckboxField = ({ model, setModel, campoId, campoIdRespuesta, title, tooltip, required, opcionTrue, opcionFalse, editable, onChange = () => {} }: FieldProps) => {
    const [resumeValue, setResumeValue] = useState<any>(undefined)
    
    useEffect(() => {
        if (campoIdRespuesta && model.resume && model.resume[campoIdRespuesta] !== undefined) {
        setResumeValue(model.resume[campoIdRespuesta])
        }
    }, [model, campoIdRespuesta])

    const handleChange = (value: boolean) => {
        setModel((prevModel : any) => ({
            ...prevModel,
            [campoId]: value
        }));
        onChange(value); 
    };

    return (
        <div className='w-auto'>
            <div className='flex items-center'>
            {title && (
                <div className="flex mb-3">
                    <span className="text-md text-[#4A5568] font-medium">{title}</span>
                    {tooltip && (
                        <div className="relative group inline-block ml-1 mt-1">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="cursor-pointer" >
                                <path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className="absolute z-50 hidden group-hover:block top-full mt-2 left-7 -translate-x-1/2 px-3 py-2 bg-[#171923] text-white text-sm text-center rounded-lg shadow-lg max-w-[412px] w-max break-words" >
                                {tooltip}
                            </div>
                        </div>
                    )}
                    <div className="flex ml-2.5 items-center">
                        {resumeValue !== undefined && (
                            <div className={`${typeof resumeValue === "number" ? getResultColorClass(resumeValue) : "bg-[#EDF2F7] text-[#4A5568]"} w-auto px-1 h-[16px] text-center rounded-[2px] text-xs font-normal`}>
                                {typeof resumeValue === "number" ? resumeValue.toFixed(1) : resumeValue}
                            </div>
                        )}
                    </div>
                </div>
            )}
            </div>
            <div className='mt-2 text-md flex items-center'>
                <label className="flex items-center mr-[40px]">
                    <input
                        className='peer hidden'
                        type="radio"
                        name={campoId}
                        required={required}
                        checked={model[campoId] === true}
                        onChange={() => handleChange(true)}
                        disabled={!editable}
                    />
                    <div className={`w-[16px] h-[16px] border border-gray-300 rounded-full peer-checked:border-[5px] peer-checked:border-[#390094]`}></div>
                    <span className='ml-2 text-[#171923]'>{opcionTrue}</span>
                </label>
                <label className='flex items-center ml-24'>
                    <input
                        className='peer hidden'
                        type="radio"
                        required={required}
                        name={campoId}
                        checked={model[campoId] === false}
                        onChange={() => handleChange(false)}
                        disabled={!editable}
                    />
                    <div className={`w-[16px] h-[16px] border border-gray-300 rounded-full peer-checked:border-[5px] peer-checked:border-[#390094]`}></div>
                    <span className='ml-2 text-[#171923]'>{opcionFalse}</span>
                </label>
            </div>
        </div>
    );
};

export default CheckboxField;
